import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Conversation } from '../api/types';
import config from '../config';

async function getConversationMessages(axios: AxiosInstance, conversationId: number): Promise<Conversation> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/conversation/` + conversationId);
  return data;
}

export default function useConversationMessagesQuery(conversationId: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(conversationId),
    queryFn: () => getConversationMessages(axios, conversationId),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
    enabled: !!conversationId,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(conversationId: number) {
  return ['Conversation', conversationId] as const satisfies QueryKey;
}

useConversationMessagesQuery.getKey = getKey;
